<ccp-data-table [tableConfigs]="tableConfigs" [columns]="columns" [toolbarConfigs]="toolbarConfigs"
  [filterUpdates]="filterUpdates" [reloadTableTriggered]="reloadTableTriggered" class="table-min-height"
  (onRowSelectionChange)="onRowSelectionChange($event)">
</ccp-data-table>
<!-- customized cell template -->
<ng-template #statusTemplate let-value="value">
  <acl-ngx-icon [name]="value"></acl-ngx-icon>
</ng-template>
<ng-template #labelTemplate let-value="value">
  <span class="label-chip-wrapper">
    <ng-container *ngFor="let label of value">
      <acl-ngx-chip [text]="label" (click)="onLabelClick($event, label)"></acl-ngx-chip>
    </ng-container>
    <span *ngIf="!value || !value.length"> - </span>
  </span>
</ng-template>